var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportBad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 14.4404,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 14.4404)",
    fill: "#C8253C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 13.374,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 13.374)",
    fill: "#C8253C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.289,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 110.962,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 110.962)",
    fill: "#C8253C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 117.359 110.962)",
    fill: "#C8253C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.97656,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 6.97656 110.962)",
    fill: "#C8253C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 109.895,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 109.895)",
    fill: "#C8253C"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_0_3752_129277_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#DF2B44",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#DF2B44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2998 101.014C92.8488 100.465 93.7391 100.465 94.2881 101.014C94.8371 101.563 94.837 102.453 94.2881 103.002L90.7832 106.507L94.2881 110.012C94.837 110.561 94.8371 111.451 94.2881 112C93.7391 112.549 92.8488 112.549 92.2998 112L88.7949 108.495L85.29 112C84.741 112.549 83.8507 112.549 83.3018 112C82.7529 111.451 82.7529 110.561 83.3018 110.012L86.8066 106.507L83.3018 103.002C82.753 102.453 82.7528 101.563 83.3018 101.014C83.8507 100.465 84.741 100.465 85.29 101.014L88.7949 104.519L92.2998 101.014ZM94.0752 101.775L94.0762 101.776L94.0752 101.775ZM84.6748 101.286H84.6758H84.6748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9092 104.38C67.9091 106.356 66.3073 107.958 64.3311 107.958H13.6328C11.6566 107.958 10.0548 106.356 10.0547 104.38V57.8574H64.3311C66.3074 57.8575 67.9092 59.4601 67.9092 61.4365V104.38Z",
    fill: "#C9D1DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85938 60.2437C8.85938 58.2673 10.4616 56.665 12.438 56.665H63.1356C65.112 56.665 66.7142 58.2673 66.7142 60.2437V82.9084H8.85938V60.2437Z",
    fill: "url(#paint0_linear_3752_129277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7904 94.8374C28.0729 94.8374 20.1953 86.9599 20.1953 77.2425C20.1953 67.525 28.0729 59.6475 37.7904 59.6475C47.5078 59.6475 55.3854 67.525 55.3854 77.2425C55.3854 86.9599 47.5078 94.8374 37.7904 94.8374ZM37.7904 63.1665C37.46 63.1665 37.1323 63.1778 36.8076 63.2002C36.7474 63.2765 36.6826 63.3605 36.6137 63.4524C36.1749 64.0375 35.5728 64.9378 34.9653 66.1527C34.419 67.2454 33.8667 68.5954 33.4248 70.2045H42.1559C41.714 68.5954 41.1617 67.2454 40.6154 66.1527C40.0079 64.9378 39.4058 64.0375 38.967 63.4524C38.8981 63.3605 38.8333 63.2765 38.7731 63.2002C38.4484 63.1778 38.1207 63.1665 37.7904 63.1665ZM28.9928 77.2425C28.9928 76.0025 29.0618 74.8294 29.1847 73.7235H24.1578C23.8683 74.8482 23.7143 76.0273 23.7143 77.2425C23.7143 78.4576 23.8683 79.6367 24.1578 80.7614H29.1847C29.0618 79.6555 28.9928 78.4824 28.9928 77.2425ZM29.7929 84.2804H25.5974C27.0442 86.7815 29.2384 88.796 31.8746 90.0187L31.8178 89.9059C31.0688 88.4079 30.3279 86.532 29.7929 84.2804ZM33.4248 84.2804L42.1559 84.2804C41.714 85.8895 41.1617 87.2395 40.6154 88.3322C40.0079 89.5471 39.4058 90.4474 38.967 91.0325C38.8981 91.1244 38.8333 91.2084 38.7731 91.2847C38.4484 91.3071 38.1207 91.3184 37.7904 91.3184C37.46 91.3184 37.1323 91.3071 36.8076 91.2847C36.7474 91.2084 36.6826 91.1244 36.6137 91.0325C36.1749 90.4474 35.5728 89.5471 34.9653 88.3322C34.419 87.2395 33.8667 85.8895 33.4248 84.2804ZM42.8524 80.7614L32.7283 80.7614C32.5908 79.6699 32.5118 78.497 32.5118 77.2425C32.5118 75.9879 32.5908 74.815 32.7283 73.7235H42.8524C42.9899 74.815 43.0689 75.9879 43.0689 77.2425C43.0689 78.497 42.9899 79.6699 42.8524 80.7614ZM45.7878 84.2804C45.2528 86.532 44.5119 88.4079 43.7629 89.9059L43.7061 90.0187C46.3423 88.796 48.5365 86.7815 49.9833 84.2804H45.7878ZM51.4229 80.7614H46.396C46.5189 79.6555 46.5879 78.4824 46.5879 77.2425C46.5879 76.0025 46.5189 74.8294 46.396 73.7235H51.4229C51.7124 74.8482 51.8664 76.0273 51.8664 77.2425C51.8664 78.4576 51.7124 79.6367 51.4229 80.7614ZM31.8178 64.579C31.0688 66.077 30.3279 67.9529 29.7929 70.2045H25.5974C27.0442 67.7034 29.2384 65.6889 31.8746 64.4662L31.8178 64.579ZM43.7061 64.4662C46.3423 65.6889 48.5365 67.7034 49.9833 70.2045H45.7878C45.2528 67.9529 44.5119 66.077 43.7629 64.579L43.7061 64.4662Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85938 82.9082H66.7142V103.187C66.7142 105.164 65.112 106.766 63.1356 106.766H12.438C10.4616 106.766 8.85938 105.164 8.85938 103.187V82.9082Z",
    fill: "url(#paint1_linear_3752_129277)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7513 103.325C22.9513 102.397 23.4462 100.387 23.3292 98.9826C23.23 97.7916 22.3526 97.693 21.3026 98.0534C19.6712 98.6133 17.8851 99.5723 17.5484 101.344C17.2998 102.652 17.12 104.836 18.8422 105.256C20.3155 105.616 21.4338 103.637 21.3325 102.407C21.2804 101.774 20.4201 102.046 20.3229 102.533C20.0554 103.873 21.6058 104.527 22.7758 104.352C23.3677 104.264 23.8203 103.905 24.1668 103.452C24.2373 103.359 24.3803 102.937 24.5557 103.058C25.0415 103.393 25.5549 103.619 26.0588 103.911",
    stroke: "#C4CDD5",
    strokeWidth: 0.41277,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 39.2375,
    height: 1.49112,
    rx: 0.596441,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 25.9531 100.802)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 42.3609,
    height: 1.49112,
    rx: 0.596441,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 22.8281 103.485)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 7.66929,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 26.2109 87.9785)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10.2666,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 26.2109 91.5576)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 15.6139,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 26.2109 97.2236)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3.19816,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 26.1562 89.4082)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 5.78473,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 26.1562 92.9873)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7878,
    height: 0.669584,
    rx: 0.334792,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 26.1562 98.6533)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2422,
    y: 87.6797,
    width: 11.9288,
    height: 11.9288,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_129277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 87,
    width: 13,
    height: 13
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2422,
    y: 87.6797,
    width: 11.9288,
    height: 11.9288,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_129277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5357 91.2266L14.4597 91.8373C14.3068 93.0669 15.2668 94.1525 16.5059 94.1525C16.742 94.1525 16.9765 94.1932 17.1988 94.2728C18.5368 94.7522 19.9456 93.7604 19.9456 92.3392V91.6183C19.9456 91.2929 19.84 90.9764 19.6449 90.7161L19.246 90.1841C18.9341 89.7682 18.5234 89.4366 18.0512 89.2192C17.2381 88.845 16.2736 89.1114 15.7679 89.85L15.6379 90.04C15.0533 90.1569 14.6092 90.635 14.5357 91.2266Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5469 101.888V99.2157C12.5469 97.7329 13.7215 96.5166 15.2034 96.4649L15.9324 96.4395H17.9981L18.6672 96.4632C20.1684 96.5165 21.3761 97.7151 21.4409 99.2157V101.888L16.945 102.76L12.5469 101.888Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 96.2652V95.3549C15.9492 95.2279 16.0522 95.125 16.1791 95.125H17.6735C17.8005 95.125 17.9035 95.2279 17.9035 95.3549V96.2652C17.9035 96.309 17.916 96.3518 17.9395 96.3888L18.2294 96.8445C18.2793 96.9229 18.3058 97.014 18.3058 97.1069C18.3058 97.2412 18.2506 97.3696 18.1531 97.4619L17.8764 97.724C17.3726 98.201 16.5893 98.2187 16.0645 97.7649L15.7099 97.4582C15.6064 97.3687 15.5469 97.2386 15.5469 97.1018C15.5469 97.0122 15.5724 96.9244 15.6205 96.8488L15.9132 96.3888C15.9367 96.3518 15.9492 96.309 15.9492 96.2652Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4261 93.3629L19.261 93.7206C19.2031 93.8461 19.0958 93.9422 18.9646 93.9859C18.8756 94.0156 18.8025 94.0801 18.762 94.1648L18.4573 94.802C18.288 95.156 17.9861 95.4291 17.6169 95.562L17.5186 95.5974C17.0258 95.7748 16.4865 95.7748 15.9937 95.5974C15.573 95.4459 15.2574 95.092 15.155 94.6567L14.982 93.9213C14.901 93.5771 14.8881 93.2203 14.944 92.8711L14.9797 92.6479C15.0522 92.1948 15.2049 91.7583 15.4306 91.3588L15.7463 90.8002C15.7928 90.718 15.9031 90.6994 15.9739 90.7619L16.7769 91.4705C16.8011 91.4919 16.8296 91.5079 16.8604 91.5175L17.7333 91.7904L18.0603 91.9281C18.529 92.1254 18.8454 92.5712 18.8771 93.0787C18.8788 93.1054 18.9143 93.1134 18.9273 93.09L19.0406 92.886C19.0998 92.7795 19.2507 92.7734 19.3183 92.8748L19.3973 92.9933C19.4705 93.1031 19.4814 93.2431 19.4261 93.3629Z",
    fill: "url(#paint2_linear_3752_129277)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.85938,
    y1: 82.7591,
    x2: 66.7142,
    y2: 82.7591,
    stroke: "black",
    strokeWidth: 0.298221
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3752_129277_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_129277",
    x1: 33.5396,
    y1: 58.0493,
    x2: 33.8533,
    y2: 83.5649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_129277",
    x1: 38.924,
    y1: 106.267,
    x2: 38.1339,
    y2: 83.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_129277",
    x1: 15.8419,
    y1: 91.4504,
    x2: 18.0738,
    y2: 95.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportBad1);
export default __webpack_public_path__ + "static/media/PassportBad1.ca6981423a131f64cb8106769f1c417b.svg";
export { ForwardRef as ReactComponent };